import { Controller } from "@hotwired/stimulus"

/**
 * Bulk Select Controller
 * Manages visual checkbox selection in survey table (no grouped actions for now)
 */
export default class extends Controller {
  static targets = ["selectAll", "checkbox"]

  connect() {
    this.updateUI()
  }

  toggleAll() {
    const isChecked = this.selectAllTarget.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = isChecked
    })
    this.updateUI()
  }

  toggleOne() {
    this.updateUI()
  }

  updateUI() {
    const total = this.checkboxTargets.length
    const checked = this.checkboxTargets.filter(cb => cb.checked).length

    if (total === 0) {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = false
      return
    }

    if (checked === 0) {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = false
    } else if (checked === total) {
      this.selectAllTarget.checked = true
      this.selectAllTarget.indeterminate = false
    } else {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = true
    }
  }
}
